<section class="p-12 flex flex-col justify-center items-center h-full">
  <img class="h-12 w-12 mb-8" src="/assets/images/emojis/1f433.svg" alt="fish emoji" />
  <h1 class="text-3xl">{{ 'error404.title' | translate }}</h1>
  <p class="text-center my-8 max-w-screen-sm">
    {{ 'error404.description' | translate }}
  </p>
  <button [routerLink]="['/']" mat-flat-button color="primary">{{ 'error404.button' | translate }}</button>
</section>
